// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"733565bd","57":"64571ae6","189":"c1c016c4","312":"b2f3acc0","313":"ea4757a1","350":"240cf630","514":"00311038","646":"55d5c4ec","729":"2305806a"}[chunkId] + ".chunk.js";
};